import { Navigate, useRoutes } from "react-router-dom";
//导入懒加载组件
import Home from "../views/Home";
import Wangyi from "../views/Wangyi";
import HomeImage from '../views/HomeImage'
import About from "../views/About";
import Helper from "../views/Helper";
import LandPage from "../views/LandPager";
import NewLandPage from "../views/NewLandPage";
import WYLandPage from "../views/WYLandPage";
import PrivacePolicy from "../views/PrivacePolicy";
import UserAgreement from "../views/UserAgreement";
import KantuPrivacePolicy from "../views/yunqiKantu/PrivacePolicy";
import KantuUserAgreement from "../views/yunqiKantu/UserAgreement";
import PageDetails from "../views/PageDetails";

// 首页模块
const homeRouter = [
  {
    path: "/wap",
    element: <Navigate to="/" />,
  },
  {
    path: "/",
    element: <Home />,
  },


  {
    path: "/pdf",
    element: <Home />,
  },
  {
    path: "/image",
    element: <Home />,
  },
  {
    path: "/video",
    element: <Home />,
  },
  {
    path: "/WYLandPage",
    element: <WYLandPage />,
  },
  {
    path: "/homeImage",
    element: <HomeImage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/LandPage",
    element: <LandPage />,
  },
  {
    path: "/NewLandPage",
    element: <NewLandPage />,
  },
  {
    path: "/helper",
    element: <Helper />,
  },
  {
    path: "/PageDetails",
    element: <PageDetails />,
  },
  {
    path: "/privacePolicy",
    element: <PrivacePolicy />,
  },
  {
    path: "/userAgreement",
    element: <UserAgreement />,
  },
  {
    path: "/Wangyi",
    element: <Wangyi />,
  },
  {
    path: "/yunqiKantu",
    element: <KantuPrivacePolicy />,
    children: [
      {
        path: "/yunqiKantu/privacePolicy",
        element: <KantuPrivacePolicy />,
      },
      {
        path: "/yunqiKantu/userAgreement",
        element: <KantuUserAgreement />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

const Routes = () => {
  const routes = useRoutes(homeRouter);
  return routes;
};

export default Routes;
